module.exports = __webpack_public_path__ + "img/car_placeholder.e5770970.png";